module.exports = __webpack_public_path__ + "media/images/pro_profiles/profile-picture-man-4ac39a60b1f9700afcc0a856c9e446eb.jpg";